import React from 'react';

const Gallery: React.FC = () => <section aria-label="gallery" />;

export default Gallery;
